import { render, staticRenderFns } from "./RegisterHousemateView.vue?vue&type=template&id=b9cb9702&scoped=true&"
import script from "./RegisterHousemateView.vue?vue&type=script&lang=ts&"
export * from "./RegisterHousemateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cb9702",
  null
  
)

export default component.exports